import { Article } from './article'
import { CommentImage } from './image'
import { User } from './user'

export interface Comment {
  article: Article
  [key: string]: any
  id: number
  message: string
  user_id: number
  create_date: string
  moderated_at: string | null
  delete_status: number
  root: number
  l_key: number
  r_key: number
  level: number
  model: number
  best: number
  reply_user_id: number | null
  parent_id: number
  user: User
  projectId: number
  images: CommentImage[]
  auto_moderation_status: number
  auto_moderation_reason: string | null
  approved_by_user: Pick<
    User,
    'id' | 'local_id' | 'first_name' | 'last_name'
  > | null
}

export enum CommentsStatus {
  NEW_COMMENT = 0,
  PUBLISHED = 1,
  DELETE = 3,
  DEFERRED = 5,
  PUBLISH_DELAYED = 6,
}

export enum AutoModerationStatus {
  PUBLISHED = 1,
  WAITING = 2,
  DELETE = 3,
}

export enum AutoModerationReason {
  OFFENSIVE = 'offensive',
  SPAM = 'spam',
  OTHER = 'other',
  DUPLICATE = 'duplicate',
}

export interface CommentTabs {
  title: string
  icon: string
  slug: number
  filter: string
  id: number
  disabled: boolean
  count?: number
}
